import { theme } from '@fiverr-private/theme';
import { EnrichedTagsLayout, TagsLayout } from '../types';
import { parsePx } from './general/parsePx';

export const buildEnrichedTagsLayout = (tagsLayout: TagsLayout): EnrichedTagsLayout => {
    const paddingYSizePx = parsePx(theme.spacing[tagsLayout.paddingY]);
    const lineHeightSizePx = parsePx(theme.bodyLineHeights[tagsLayout.lineHeight]);

    return {
        ...tagsLayout,
        paddingYSizePx,
        lineHeightSizePx,
        gapSizePx: parsePx(theme.spacing[tagsLayout.gap]),
        tagLineHeightPx: lineHeightSizePx + paddingYSizePx * 2,
    };
};
